import {CommonMessages} from '../common.messages';

export const MarketDataUsageReportsMessages = {
    GetMarketDataUsageReportsFailed: {
        key: 'GetMarketDataUsageReportsFailed',
        message: 'Error while communication with the server. Unable to get usage reports.'
    },
    GetMarketDataUsageReportsNoData: {
        key: 'GetMarketDataUsageReportsNoData',
        message: 'No usage reports data.'
    },
    GetUserAccountsFailed: {
        key: 'GetUserAccountsFailed',
        message: 'Error while communication with the server. Unable to get accounts.'
    },
    GetUsersFailed: {
        key: 'GetUsersFailed',
        message: 'Error while communication with the server. Unable to get users.'
    },
    ...CommonMessages
};
